export const MEDLEMSORGANISASJON = {
  943942102: 'DET FRIVILLIGE SKYTTERVESEN ',
  956792150: 'NORGES JEGER- OG FISKERFORBUND ',
};
